// Módulo contenedor del token de Auth0 a nivel de módulo.
// Se actualiza desde TokenProvider cuando el token se obtiene/refresca.
// Este enfoque evita re-renders de React y está disponible en el momento de cada petición RTK Query.
//
// NOTA: Este holder es exclusivo para entornos de navegador (browser/single-session).
// No se debe usar en SSR — las funciones se convierten en no-op fuera del navegador
// para evitar que un token de una sesión contamine otras sesiones del servidor.

const isBrowser = typeof window !== 'undefined';

let currentToken = null;

// Promesa que se resuelve la primera vez que se establece un token válido.
// Permite que las peticiones que llegan antes del primer setAuthToken esperen
// en lugar de salir sin token y recibir un 401 cuando el proxy requiera auth.
let resolveTokenReady;
export const tokenReadyPromise = new Promise((resolve) => {
  resolveTokenReady = resolve;
});

export const setAuthToken = (token) => {
  if (!isBrowser) return;
  currentToken = token;
  if (token) {
    // Resolver la promesa al primer token válido (idempotente en llamadas posteriores)
    resolveTokenReady(token);
  }
};

export const getAuthToken = () => {
  if (!isBrowser) return null;
  return currentToken;
};

// Cabeceras para llamadas fetch imperativas (las edge functions admin de
// provisión: create-user/reset-password/create|block|unblock-auth0-user) que
// deben reenviar el bearer de Auth0 cuando EDGE_REQUIRE_AUTH esté activo.
// Uso: fetch(url, { headers: authHeaders({ 'Content-Type': 'application/json' }) })
export const authHeaders = (extra = {}) => {
  const token = getAuthToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
};
